export { default as ProductTemplateLayout } from './components/ProductTemplateLayout'
